import { TopPosterModel } from 'models/body/TopPosterModel'
import React, { Fragment, FunctionComponent, ReactNode, useEffect, useState } from 'react'
import Fade from 'react-reveal/Fade'
import cookie from 'js-cookie'

type Props = {
  data: TopPosterModel
}

const TopPoster = (props: Props) => {
  const [isOpen, setIsOpen] = useState(true)
  const hasCookie = cookie.get('poster-closed')
  const closePoster = () => {
    cookie.set('poster-closed', 'true')
    setIsOpen(false)

    
    setTimeout(()=> {
      const anyHero = document.getElementById('any-hero');
      const headerContainer = document.getElementById('header-container');

      if (anyHero !== undefined) {
        // @ts-ignore
        anyHero.style.paddingTop = `${headerContainer?.clientHeight}px`;
      }
    })
  }

  useEffect(() => {
    if (hasCookie) {
      setIsOpen(false)
    }
    return () => {}
  }, [])

  return (
    <Fragment>
      {isOpen && hasCookie === undefined && (
        <div className="popup-banner w-full px-[60px] py-[14px] text-white text-lg flex gap-x-6 flex-wrap justify-center lg:justify-evenly lg:items-center">
          <span>{props.data.attributes?.title}</span>
          <a
            className="bg-white text-black rounded-[14px] text-xs uppercase mt-3 lg:mt-0 px-[15px] py-[6px] inline-block ease-in duration-300 hover:opacity-90 text-center"
            href={props.data.attributes?.buttonLink}
            target="_blank"
            rel="noreferrer"
          >
            {props.data.attributes?.buttonText}
          </a>
          <button onClick={closePoster} className="popup-close absolute right-5 top-[14px] text-lg font-bold">
            X
          </button>
        </div>
      )}
    </Fragment>
  )
}

export default TopPoster
